<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/ded#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/epigraph#ep">Epigraphs</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">A Good-Looking Kid</a></p>
<p class="toc"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">The Drowned Baby Pond</span></p>
<p class="toc"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">The Tour de France</span></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Only the Lonely</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Dad’s New Girlfriend</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">A little about my mother?</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">The Pilgrim</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">The Collector</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">A Cured Man</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">The Succession is Secured</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">A Folklorist’s Delight</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">An Uncle to the Boy</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6d5655b9